import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Loader2 } from 'lucide-react';
import { api } from '../apiClient';
import { useAuth } from '../AuthContext';
import EventCard from '../components/EventCard';

export default function WishlistPage() {
  const navigate = useNavigate();
  const { isAuthed, loading: authLoading } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const r = await api.get('/wishlist');
      setItems(r.data);
    } catch {
      setItems([]);
    }
  }, []);

  useEffect(() => {
    if (!isAuthed) { setLoading(false); return; }
    setLoading(true);
    load().finally(() => setLoading(false));
  }, [isAuthed, load]);

  if (authLoading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-brand-magenta" /></div>;

  if (!isAuthed) {
    return (
      <div className="max-w-7xl mx-auto px-6" data-testid="wishlist-page">
        <h1 className="text-2xl font-black text-gray-900 tracking-tight py-4">Wishlist</h1>
        <div className="flex flex-col items-center justify-center py-20" data-testid="wishlist-guest-empty">
          <Heart className="w-16 h-16 text-gray-300 mb-4" />
          <h3 className="text-lg font-extrabold text-gray-900">Sign in to save events</h3>
          <p className="text-sm text-gray-500 mt-1 text-center">Keep track of events you love and enquire when ready.</p>
          <button
            data-testid="wishlist-signin-btn"
            onClick={() => navigate('/login')}
            className="mt-5 bg-brand-magenta hover:bg-pink-700 text-white px-6 py-3 rounded-2xl font-extrabold text-sm transition-colors"
          >
            Sign In
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-6" data-testid="wishlist-page">
      <h1 className="text-2xl font-black text-gray-900 tracking-tight py-4">Wishlist</h1>
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-brand-magenta" /></div>
      ) : items.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-20" data-testid="wishlist-empty">
          <Heart className="w-16 h-16 text-gray-300 mb-4" />
          <h3 className="text-lg font-extrabold text-gray-900">No saved events yet</h3>
          <p className="text-sm text-gray-500 mt-1 text-center">Tap the heart on any event to add it here.</p>
          <button
            onClick={() => navigate('/')}
            className="mt-5 bg-brand-magenta hover:bg-pink-700 text-white px-6 py-3 rounded-2xl font-extrabold text-sm transition-colors"
          >
            Browse Events
          </button>
        </div>
      ) : (
        <div className="flex flex-col gap-3 pb-8">
          {items.map((item) => (
            <EventCard key={item.id} event={item} variant="wide" />
          ))}
        </div>
      )}
    </div>
  );
}
